<template>
  <optgroup v-for="(group, i) in options" :key="i" :label="group.label">
    <option
      v-for="option in group.options"
      :key="option.value"
      :value="option.value"
    >
      {{ option.text }}
    </option>
  </optgroup>
</template>

<script setup lang="ts">
import type { FormSelectOptionsGroup } from "./types";

type FormInputProps = {
  options: FormSelectOptionsGroup[];
};

defineProps<FormInputProps>();
</script>
